<template>
    <section>
        <b-modal :active.sync="showWatchMovieModal"
        		has-modal-card
            	trap-focus
                aria-role="dialog"
                aria-modal
                scroll="keep">
    		<form action="">
                <div class="modal-card" style="width: 600px">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Watch your trafficmovie</p>
                    </header>

                    <section class="modal-card-body">
                    	<video controls autoplay muted loop>
							<source :src="movie_url"/>
						</video>
                    </section>

                    <footer class="modal-card-foot">
                    	<div class="buttons has-text-centered" style="width: 100%">
                			<b-button type="is-primary" @click="changeWatchMovieModalState">Close</b-button>
                			<b-button class="is-link" tag="a" v-bind:href="movie_url">
                                <b-icon icon="cloud-download"></b-icon>
                                <span>Download</span>
                            </b-button>
						</div>
                    </footer>

                </div>
            </form>
    	</b-modal>
    </section>
</template>

<script>
	export default {
		name: 'WatchMovieModal',

		computed: {
			showWatchMovieModal: {
				get () {
					return this.$store.getters.showWatchMovieModal
				},
				set () {
					this.$store.commit('toggleWatchMovieModal')
				}
			},
			movie_url () {
				return this.$store.state.movie_url
			}
		},


		methods: {
			changeWatchMovieModalState () {
                this.$store.commit('toggleWatchMovieModal')
            }
		}
	}
</script>

<style>
</style>